import addDomainToPath from 'commons/addDomainToPath';

function publicImgBaseURL(imgName) {
  return addDomainToPath(imgName);
}

export default publicImgBaseURL;
